import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
// import "../../../6729.css";


import image1 from "../../../images/service-fluid/4213/4213_1front.webp"
import image2 from "../../../images/service-fluid/4213/4213_1back.webp"
import image3 from "../../../images/service-fluid/4213/4213_5front.webp"
import image4 from "../../../images/service-fluid/4213/4213_5back.webp"


const images = [
    { src: image1, alt: "Front" },
     { src: image2, alt: "Back 5L" },
    { src: image3, alt: "Back" },
    { src: image4, alt: "Front 5L" },
   
];

const packageSlides = [
    { images: [image1, image2] },
    { images: [image3, image4] },
];

const TDS_URL = "https://www.fanfaro.de/create-pdf/144";

const SDS_FILES = [
  { code: "BE", url: "https://sct-b2b.com/out/msds/sdFF4213_-_FANFARO 4213 Coolant G13_(BE).pdf" },
  { code: "BG", url: "https://sct-b2b.com/out/msds/sdFF4213_-_FANFARO 4213 Coolant G13_(BG).pdf" },
  { code: "CZ", url: "https://sct-b2b.com/out/msds/sdFF4213_-_FANFARO 4213 Coolant G13_(CZ).pdf" },
  { code: "DE", url: "https://sct-b2b.com/out/msds/sdFF4213_-_FANFARO 4213 Coolant G13_(DE).pdf" },
  { code: "DK", url: "https://sct-b2b.com/out/msds/sdFF4213_-_FANFARO 4213 Coolant G13_(DK).pdf" },
  { code: "EE", url: "https://sct-b2b.com/out/msds/sdFF4213_-_FANFARO 4213 Coolant G13_(EE).pdf" },
  { code: "ES", url: "https://sct-b2b.com/out/msds/sdFF4213_-_FANFARO 4213 Coolant G13_(ES).pdf" },
  { code: "FI", url: "https://sct-b2b.com/out/msds/sdFF4213_-_FANFARO 4213 Coolant G13_(FI).pdf" },
  { code: "FR", url: "https://sct-b2b.com/out/msds/sdFF4213_-_FANFARO 4213 Coolant G13_(FR).pdf" },
  { code: "GR", url: "https://sct-b2b.com/out/msds/sdFF4213_-_FANFARO 4213 Coolant G13_(GR).pdf" },
  { code: "HR", url: "https://sct-b2b.com/out/msds/sdFF4213_-_FANFARO 4213 Coolant G13_(HR).pdf" },
  { code: "HU", url: "https://sct-b2b.com/out/msds/sdFF4213_-_FANFARO 4213 Coolant G13_(HU).pdf" },
  { code: "IE (EN)", url: "https://sct-b2b.com/out/msds/sdFF4213_-_FANFARO 4213 Coolant G13_(IE).pdf" },
  { code: "IT", url: "https://sct-b2b.com/out/msds/sdFF4213_-_FANFARO 4213 Coolant G13_(IT).pdf" },
  { code: "LT", url: "https://sct-b2b.com/out/msds/sdFF4213_-_FANFARO 4213 Coolant G13_(LT).pdf" },
  { code: "LV", url: "https://sct-b2b.com/out/msds/sdFF4213_-_FANFARO 4213 Coolant G13_(LV).pdf" },
  { code: "NO", url: "https://sct-b2b.com/out/msds/sdFF4213_-_FANFARO 4213 Coolant G13_(NO).pdf" },
  { code: "PL", url: "https://sct-b2b.com/out/msds/sdFF4213_-_FANFARO 4213 Coolant G13_(PL).pdf" },
  { code: "PT", url: "https://sct-b2b.com/out/msds/sdFF4213_-_FANFARO 4213 Coolant G13_(PT).pdf" },
  { code: "RO", url: "https://sct-b2b.com/out/msds/sdFF4213_-_FANFARO 4213 Coolant G13_(RO).pdf" },
  { code: "RU", url: "https://sct-b2b.com/out/msds/sdFF4213_-_FANFARO 4213 Coolant G13_(RU).pdf" },
  { code: "SE", url: "https://sct-b2b.com/out/msds/sdFF4213_-_FANFARO 4213 Coolant G13_(SE).pdf" },
  { code: "SI", url: "https://sct-b2b.com/out/msds/sdFF4213_-_FANFARO 4213 Coolant G13_(SI).pdf" },
  { code: "SK", url: "https://sct-b2b.com/out/msds/sdFF4213_-_FANFARO 4213 Coolant G13_(SK).pdf" }
];

export default function ImageWithContent() {

    const [currentIndex, setCurrentIndex] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [showSDS, setShowSDS] = useState(false);

    const [packageIndex, setPackageIndex] = useState(0);
    const [imageIndex, setImageIndex] = useState(0);

    const slideInterval = useRef(null);
    const slideDuration = 4000;

    useEffect(() => {
        startSlideTimer();
        return () => clearInterval(slideInterval.current);
    }, []);

    const startSlideTimer = () => {
        slideInterval.current = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % images.length);
        }, slideDuration);
    };

    const goToSlide = (index) => {
        setCurrentIndex(index);
        clearInterval(slideInterval.current);
        startSlideTimer();
    };

    const nextImage = () => {
        const total = packageSlides[packageIndex].images.length;
        setImageIndex((prev) => (prev + 1) % total);
    };

    const prevImage = () => {
        const total = packageSlides[packageIndex].images.length;
        setImageIndex((prev) => (prev === 0 ? total - 1 : prev - 1));
    };

    return (
       <>
         <div
            style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "flex-start",
                justifyContent: "center",
                gap: "32px",
                padding: "24px",
                fontFamily: "Arial",
            }}
        >

            {/* LEFT IMAGE CAROUSEL */}
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>

        {/* IMAGE CAROUSEL */}
        <div
          style={{
            position: "relative",
            width: "300px",
            height: "400px",
            borderRadius: "8px",
            overflow: "hidden",
          }}
        >
          {images.map((img, index) => (
            <img
              key={index}
              src={img.src}
              alt={img.alt}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                position: index === currentIndex ? "relative" : "absolute",
                opacity: index === currentIndex ? 1 : 0,
                transition: "opacity 1s",
              }}
            />
          ))}
        </div>
        <p
          style={{
            // marginTop: "15px",
            fontSize: "14px",
            color: "#0c0c0c",
            textAlign: "justify",
            lineHeight: "1.6",
            width:"250px",
            fontSize:"12px"
          }}
        >
          Attention! The packaging is illustrative and may differ from its actual appearance. For the latest list of specifications, see the text section.
        </p>


        
        {/* Amazon Button (external link) */}
        <a
          href="https://kytecarparts.com/products/fanfaro-4213-g13-ready-to-use-antifreeze-hoat-engine-coolant-imported-from-germany?"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <button
            style={{
              width: "150px",
              padding: "12px",
              backgroundColor: "#0d4d33",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              fontSize: "16px",
              cursor: "pointer",
            }}
          >
            Buy Now
          </button>
        </a>

      </div>

            {/* RIGHT CONTENT */}
            <div style={{ paddingLeft: "30px", maxWidth: "850px" }}>
                <h2>FANFARO Coolant G13
4213</h2>

                <p>

                  A hybrid (HOAT – Hybrid Organic Acid Technology) high-technology ready-to-use solution with excellent operating characteristics intended for a year-round use in any modern cooling system for which the use of mono-ethylene-glycol-based antifreeze is recommended. It ensures a reliable protection of any cooling system.
                    </p>

                <p><strong>Product properties:</strong></p>

                <ul style={{ paddingLeft: "20px" }}>
  <li>It ensures a reliable protection of metals and alloys (brass, copper, alloy-treated steel, cast iron, aluminium) from all forms of corrosion, as well as prevents a high-temperature corrosion of aluminium surfaces of modern engines;</li>
  <li>The non-organic additive package protects the surface at once and the organic part starts to act only when corrosion sources appear thus a maximum protection is reached from the start of use and the service life of the engine is extended;</li>
  <li>It has an exceptional thermal stability. It protects from deposit formation;</li>
  <li>It has excellent heat conductivity properties and a resistance to foam formation;</li>
  <li>It is neutral to inserts and hoses, compatible with all types of rubber and plastic parts of the cooling system;</li>
  <li>It has an excellent resistance to hard water and very low corrosion inhibitor depletion rates;</li>
  <li>The high-efficiency additive package ensures an exceptional stability of operating properties of the antifreeze throughout the entire service life;</li>
  <li>It contains a fluorescent dye allowing identifying even small leakages of the antifreeze in the UV light;</li>
  <li>It is a liquid with an elevated level of borates and silicates. It does not contain nitrates, phosphates and amines (the NAP free technology).</li>
         </ul> <br />

                <p>
                    {/* It is recommended for engines requiring enhanced heat dissipation: highly accelerated engines, engines with a turbocharger and cooling systems of modern commercial vehicles.<br/> */}

Colour: green.<br/>

Service life: no less than 3 years.<br/>
Comply with the manufacturer’s instructions provided in the user’s manual!  </p>


                <p style={{ color: "#4CAF50", fontWeight: "bold" }}>
                    CORRESPONDS WITH REQUIREMENTS / SPECIFICATIONS / PRODUCTS:
                </p>

                {/* SPECIFICATIONS */}
                <div style={{ display: "flex", gap: "40px", flexWrap: "wrap" }}>
                    <div>
                        <b>Specifications</b>
                        {/* <ul style={{ paddingLeft: "20px" }}>
                            <ul style={{ paddingLeft: "20px" }}>
                                <li>SAE J1703</li>
                                <li>SAE J1704</li>
                                <li>ISO 4925 Class 3</li>
                                <li>ISO 4925 Class 4</li>
                                <li>FMVSS 116 DOT 3</li>
                                <li>FMVSS 116 DOT 4</li>
                                <li>JIS K2233</li>
                            </ul>
                        </ul> */}
                    </div>


                    <div>
                        <b>Recommendation</b>
                    <ul style={{ paddingLeft: "20px" }}>
  <li>SAE J1034</li>
  <li>AFNOR FRANCE NF R15-601</li>
  <li>ASTM USA D3306</li>
  <li>ASTM USA D4340</li>
  <li>ASTM USA D4985</li>
  <li>BSI GB BS 6580:2010</li>
  <li>NATO S-759</li>
  <li>BMW GS 94000</li>
  <li>CHRYSLER MS-7170</li>
  <li>FORD ESE-M978B4H-A</li>
  <li>FORD AF Plus</li>
  <li>GM 1825 M</li>
  <li>GM 1899 M</li>
  <li>GM SATURN</li>
  <li>JAGUAR</li>
  <li>JOHN DEERE</li>
  <li>MAN 324 Typ NF</li>
  <li>MB 325.0</li>
  <li>MINI GS 94000</li>
  <li>MTU MTL 5048</li>
  <li>OPEL GME L1301</li>
  <li>OPEL GM QL130100</li>
  <li>VAUXHALL GME L1301</li>
</ul>
                    </div>

                    <div>
                        <b>PACKAGES:</b>
                        <ul style={{ paddingLeft: "20px" }}>

                            <li>
                                <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        setPackageIndex(0);
                                        setImageIndex(0);
                                        setShowModal(true);
                                    }}
                                >
                          

1L (FF4213-1)
                                </span>
                            </li>

                            <li>
                                <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        setPackageIndex(1);
                                        setImageIndex(0);
                                        setShowModal(true);
                                    }}
                                >
                                  5L (FF4213-5)
                                </span>
                            </li>

   {/*                          <li>
                                <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        setPackageIndex(2);
                                        setImageIndex(0);
                                        setShowModal(true);
                                    }}
                                >
                                    60L (FF6208-DR)
                                </span>
                            </li>

                            <li>
                                <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        setPackageIndex(3);
                                        setImageIndex(0);
                                        setShowModal(true);
                                    }}
                                >
                                    208L (FF6208-IBC)
                                </span>
                            </li> */}

                        </ul>
                    </div>
                    <div>
                        <b>SDS & TDS</b>
                        <ul style={{ paddingLeft: "20px" }}>

                            <li>
                                
                                <a
                                    href=""
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setShowSDS(true);
                                    }}
                                    style={{ textDecoration: "none", cursor: "pointer" }}
                                >
                                    📄 SDS
                                </a>
                            </li>

                            <li>
                                <a
                                    href="https://www.fanfaro.de/create-pdf/144"
                                    target="_blank"
                                    style={{ textDecoration: "none" }}>
                                    🖨️ TDS
                                </a>
                            </li>

                        </ul>
                    </div>

                </div>



            </div>

            {/* MODAL */}
            {showModal && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(0,0,0,0.6)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 999,
                    }}
                >
                    <div
                        style={{
                            background: "#fff",
                            padding: "20px",
                            width: "500px",
                            borderRadius: "8px",
                            position: "relative",
                        }}
                    >

                        <span
                            onClick={() => setShowModal(false)}
                            style={{
                                position: "absolute",
                                right: "15px",
                                top: "10px",
                                cursor: "pointer",
                                fontSize: "22px",
                            }}
                        >
                            ✕
                        </span>

                        <img
                            src={packageSlides[packageIndex].images[imageIndex]}
                            alt="package"
                            style={{
                                width: "100%",
                                maxHeight: "450px",
                                objectFit: "contain",
                            }}
                        />

                        <div style={{ textAlign: "center", marginTop: "20px" }}>

                            <button onClick={prevImage}>◀</button>

                            <span style={{ margin: "0 15px" }}>
                                {imageIndex + 1} of {packageSlides[packageIndex].images.length}
                            </span>

                            <button onClick={nextImage}>▶</button>

                        </div>

                    </div>
                </div>
            )}

            {showSDS && (
                <div className="sds-overlay" onClick={() => setShowSDS(false)}>
                    <div className="sds-modal" onClick={(e) => e.stopPropagation()}>
                        {/* Close Icon */}
                        <button
                            className="sds-close-icon"
                            onClick={() => setShowSDS(false)}
                            aria-label="Close SDS"
                        >
                            ×
                        </button>

                        <h3>Back 4L FANFARO S-4T+ 20W-50</h3>

                        <div className="sds-grid">
                            {SDS_FILES.map((file) => (
                                <a
                                    key={file.code}
                                    href={file.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {file.code}
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>

        <a
        href="https://wa.me/7204731100?text=Hello%20I%20need%20details"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
          alt="WhatsApp"
        />
      </a>
       </>
    );
}